<template>
  <div class="r-ph-16 r-pv-16">
    <h2>Video Referanslar</h2>

    <!-- Yıl/Ay filtresi için ortak FilterBar (sorular/arsiv ile aynı mantık) -->
    <filter-bar
      :show-first-row="true"
      :show-filter-button="false"
      :show-dynamic-properties="false"
      :is-loading="isLoading"
    >
      <template #first-row>
        <r-select
          v-model="selectedYearMonth"
          label="Yıl / Ay"
          :data="yearMonthOptions"
          txt="txt"
          val="val"
          width="20%"
          @change="onYearMonthChange"
        />
      </template>
    </filter-bar>

    <r-data-list
      :headdata="headdata"
      :listdata="list"
      :opt="opts"
      v-if="loaded"
    >
      <template v-slot:col9="{ datarow }">
        <input
          type="checkbox"
          :checked="datarow.isCompleted === true"
          @change="onToggleCompleted(datarow, $event)"
        />
      </template>
    </r-data-list>
  </div>
</template>

<script>
import { onBeforeMount, ref, computed } from "vue";
import { useStore } from "vuex";
import FilterBar from "@/components/FilterBar/FilterBar.vue";

export default {
  name: "PageVideoReferanslar",
  components: {
    FilterBar
  },
  setup() {
    const store = useStore();
    const list = ref([]);
    const loaded = ref(false);
    const isLoading = ref(false);

    // Yıl/Ay filtresi
    const yearMonthList = ref([]);
    const selectedYearMonth = ref(null);
    const yearMonthOptions = computed(() => {
      const arr = Array.isArray(yearMonthList.value) ? yearMonthList.value : [];
      return arr.map(x => ({ txt: x, val: x }));
    });

    const headdata = computed(() => {
      return [
        {
          title: "Yıl",
          style: { width: "8%", justifyContent: "center" },
          key: "workYear"
        },
        {
          title: "Ay",
          style: { width: "8%", justifyContent: "center" },
          key: "workMonth"
        },
        {
          title: "S. Soru No",
          style: { width: "10%", justifyContent: "center" },
          key: "examNumber"
        },
        {
          title: "Video Adı",
          style: { width: "20%" },
          key: "videoName"
        },
        {
          title: "Bölüm",
          style: { width: "15%" },
          key: "sectionName"
        },
        {
          title: "Başlangıç",
          style: { width: "10%", justifyContent: "center" },
          key: "startTime"
        },
        {
          title: "Bitiş",
          style: { width: "10%", justifyContent: "center" },
          key: "endTime"
        },
        {
          title: "Açıklama",
          style: { width: "19%" },
          key: "description"
        },
        {
          title: "Tamamlandı mı?",
          style: { width: "10%", justifyContent: "center" },
          type: "checkbox",
          key: "isCompleted"
        }
      ];
    });

    const opts = ref({
      title: "Video Referanslar",
      buttons: {
        style: { width: "0%" },
        edit: {
          show: false,
          showf: () => false
        },
        delete: {
          show: false,
          showf: () => false
        },
        add: {
          show: false,
          showf: () => false
        }
      }
    });

    const loadYearMonths = async () => {
      const res = await store.dispatch("getDatas", {
        api: "settings/getmonthyear"
      });
      const arr = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.Data)
        ? res.Data
        : [];
      yearMonthList.value = Array.isArray(arr) ? arr : [];
    };

    const loadList = async (workMonth, workYear) => {
      if (!workMonth || !workYear) return;
      isLoading.value = true;
      try {
        const res = await store.dispatch("getDatas", {
          api: "VideoReferences/list",
          params: {
            workmonth: workMonth,
            workyear: workYear
          }
        });
        const arr = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.Data)
          ? res.Data
          : [];
        list.value = Array.isArray(arr) ? arr : [];
      } finally {
        isLoading.value = false;
      }
    };

    const onYearMonthChange = e => {
      if (!e || !e.val) return;
      selectedYearMonth.value = e.val;
      const parts = e.val.split("-");
      if (parts.length === 2) {
        const [year, month] = parts;
        loadList(month, year);
      }
    };

    const isUpdating = ref(false);
    const onToggleCompleted = async (row, evt) => {
      if (isUpdating.value) return;
      isUpdating.value = true;
      try {
        const newVal = evt.target.checked;

        // Optimistic UI
        row.isCompleted = newVal;

        await store.dispatch("putDatas", {
          api: `VideoReferences/${row.id}`,
          data: {
            id: row.id,
            questionId: row.questionId,
            videoName: row.videoName,
            sectionName: row.sectionName,
            startTime: row.startTime,
            endTime: row.endTime,
            description: row.description,
            isCompleted: newVal
          }
        });
      } finally {
        isUpdating.value = false;
      }
    };

    onBeforeMount(async () => {
      // Yıl-Ay kombinasyonlarını yükle (en güncel dönem varsayılan)
      await loadYearMonths();
      if (yearMonthList.value.length > 0) {
        const chosen = yearMonthList.value[0];
        selectedYearMonth.value = chosen;
        const parts = String(chosen).split("-");
        if (parts.length === 2) {
          const [year, month] = parts;
          await loadList(month, year);
        }
      }
      loaded.value = true;
    });

    return {
      list,
      loaded,
      isLoading,
      yearMonthList,
      selectedYearMonth,
      yearMonthOptions,
      headdata,
      opts,
      onYearMonthChange,
      onToggleCompleted
    };
  }
};
</script>
